const plansFilterResources = {
    filterPlansTitle: 'Select Health Programs'
};
export default plansFilterResources;